import { z } from "zod";

export const CSV_IMPORT_WORKFLOW = "csv.import";
export const csvImportWorkflow = {
  key: CSV_IMPORT_WORKFLOW,
  name: "CSV import",
  tasks: [{ key: "import_csv_rows", name: "Import CSV rows" }],
} as const;
export const csvImportRequestSchema = z.object({
  workspaceId: z.uuid(),
  importId: z.uuid(),
  requestedBy: z.uuid(),
  afterRow: z.number().int().nonnegative().default(0),
});
export type CsvImportRequest = z.infer<typeof csvImportRequestSchema>;
export const csvImportBatchSchema = csvImportRequestSchema.extend({ runId: z.uuid() });
export type CsvImportBatch = z.infer<typeof csvImportBatchSchema>;
export interface CsvImportBatchResult {
  afterRow: number;
  total: number;
  completed: number;
  done: boolean;
}
export interface CsvImportRun {
  workflowId: string;
  runId: string;
  status: string;
  scanned: number;
  error: string | null;
}
export const csvImportWorkflowId = (workspaceId: string, importId: string) =>
  `import/${workspaceId}/${importId}`;
